const baseUrl = "https://"+window.location.hostname;
const suffix = (baseUrl === "https://localhost" ? ":42000" : (baseUrl.split(".")[1] === "168" ? ":42000" : "/back"));
let urlAxios = (baseUrl + suffix + "/kagedoc/").toString();
let urlAxiosCore = (baseUrl + suffix + "/core/").toString();

export { baseUrl, suffix, urlAxios, urlAxiosCore };
